import { render, staticRenderFns } from "./form-address.html?vue&type=template&id=3d7bf9a8&scoped=true&"
import script from "./form-address.js?vue&type=script&lang=js&"
export * from "./form-address.js?vue&type=script&lang=js&"
import style0 from "./form-address.css?vue&type=style&index=0&id=3d7bf9a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7bf9a8",
  null
  
)

export default component.exports